import { Squares2X2Icon } from '@heroicons/react/24/outline';
import { useAppSelector } from 'app/hooks';
import GridDraggableItem from 'components/structure-page/2d/grid-draggable-item';
import { useMemo } from 'react';
import { selectActivePtacConfiguration } from 'utils/active-ptac-configuration';
import {
  PTAC_UNIT_CARD_ID,
  PTAC_UNITS_PANEL_ID,
  ptacUnitsPlacedCount
} from 'utils/ptac-configuration-sections';

const PTAC_UNIT_CATALOG_ITEM = {
  label: 'PTAC Unit',
  image: '/images/air-handlers/ptac-unit.svg',
  description:
    "Through-the-wall unit. Drag onto a zone to mount it on that room's outside wall"
};

export const PTAC_UNITS_ALL_PLACED_TOOLTIP =
  'Every zone already has its unit. Drag a unit off the plan to place it again.';

type PtacUnitsPanelProps = {
  readOnly?: boolean;
};

export default function PtacUnitsPanel({
  readOnly = false
}: PtacUnitsPanelProps) {
  const estimatingStructure = useAppSelector(
    (state) => state.ui.estimatingStructure
  );
  const configuration = useAppSelector(selectActivePtacConfiguration);
  const { placed, total } = useMemo(
    () => ptacUnitsPlacedCount(configuration),
    [configuration]
  );
  const allPlaced = total > 0 && placed === total;

  return (
    <div id={PTAC_UNITS_PANEL_ID} className='flex flex-col gap-3'>
      <div className='flex items-center gap-1'>
        <Squares2X2Icon className='h-6 w-6' />
        <span className='text-lg font-semibold'>PTAC Units</span>
        <span className='ml-auto text-sm text-gray-500'>
          {placed}/{total} placed
        </span>
      </div>
      <GridDraggableItem
        id={PTAC_UNIT_CARD_ID}
        label={PTAC_UNIT_CATALOG_ITEM.label}
        type='new-ptac-unit'
        color='purple'
        image={PTAC_UNIT_CATALOG_ITEM.image}
        description={PTAC_UNIT_CATALOG_ITEM.description}
        size='large'
        disabled={readOnly || estimatingStructure || allPlaced}
        tooltip={allPlaced ? PTAC_UNITS_ALL_PLACED_TOOLTIP : undefined}
      />
    </div>
  );
}
